import React from 'react'
import { Box } from '@mui/material'
import ConnectionTypeSelector from '../molecules/ConnectionTypeSelector'
import GmailConfigurationSection from '../molecules/GmailConfigurationSection'
import ManualConfigurationSection from '../molecules/ManualConfigurationSection'

const EmailSettingsTabContent = ({
  control,
  errors,
  connectionType,
  isPasswordShown,
  languageGSD,
  userEditState,
  onConnectionTypeChange,
  onTogglePassword
}) => {
  return (
    <Box className="p-3" style={{ minHeight: '25rem' }}>
      <ConnectionTypeSelector
        connectionType={connectionType}
        onChange={onConnectionTypeChange}
      />

      {connectionType === 'gmail' && (
        <GmailConfigurationSection
          languageGSD={languageGSD}
          userEditState={userEditState}
        />
      )}

      {connectionType === 'manual' && (
        <ManualConfigurationSection
          control={control}
          errors={errors}
          isPasswordShown={isPasswordShown}
          onTogglePassword={onTogglePassword}
        />
      )}
    </Box>
  )
}

export default EmailSettingsTabContent
